import { addDays, format, startOfISOWeek } from 'date-fns';
import * as React from 'react';
import { MediaItem, MediaType } from '../../../store/types';

export interface MediaInfoProps {
  media: MediaItem;
}

export class MediaInfo extends React.PureComponent<MediaInfoProps> {
  private getWeekdaysByName = (dayNo: number) => {
    const startOfIsoWeek = startOfISOWeek(new Date());
    return format(addDays(startOfIsoWeek, dayNo), 'dddd');
  };

  private isDayValid = (dayNo: number) => {
    const diffusion = this.props.media.diffusionDays.toString(2);
    const pad = '0000000';
    const result = (pad + diffusion).slice(-pad.length);

    if (result[dayNo] === '1') {
      return 'valid';
    } else {
      return 'invalid';
    }
  };

  private generateThumbnailUrl = () => {
    switch (this.props.media.mediaType) {
      case MediaType.Image:
      case MediaType.Video:
      case MediaType.Flash:
      case MediaType.HtmlTemplate:
      case MediaType.HtmlInstance:
      case MediaType.FlashEditableTemplate:
      case MediaType.FlashEditable:
      case MediaType.WebPage:
        return (
          '/v5/medias/' +
          this.props.media.contentFileId +
          '/thumbnails/' +
          this.props.media.contentFileId +
          '_big_1.jpg'
        );

      case MediaType.Audio:
        return '/v6/Content/images/font-awesome_file_audio.png';
      case MediaType.TvPassThru:
        return '/v5/medias/tvpassthru/thumbnails/tvpassthru_big_1.jpg';
      case MediaType.TunerTv:
        return '/v5/medias/tunertv/thumbnails/tunertv_big_1.jpg';
      case MediaType.AdvancedLocalInputPlaylistChild:
        return '/v5/medias/playlistlocalinputchild/thumbnails/playlistlocalinputchild_big_1.jpg';
      case MediaType.AdvancedLocalInputPlaylistParent:
        return '/v5/medias/playlistlocalinputparent/thumbnails/playlistlocalinputparent_big_1.jpg';
      case MediaType.AdvancedLocalInputTagChild:
        return '/v5/medias/taglocalinputparent/thumbnails/taglocalinputparent_big_1.jpg';
      case MediaType.AdvancedLocalInputTagParent:
        return '/v5/medias/taglocalinputchild/thumbnails/taglocalinputchild_big_1.jpg';
      case MediaType.EventPlaylist:
      case MediaType.Playlist:
        return '/v5/medias/playlist/thumbnails/playlist_big_1.jpg';
      case MediaType.Tag:
        return '/v5/medias/tag/thumbnails/tag_big_1.jpg';

      case MediaType.Channel:
        return '/v5/medias/channel/thumbnails/channel_big_1.jpg';

      case MediaType.DesignInstance || MediaType.DesignTemplate:
        return '/v5/medias/designinstance/thumbnails/designinstance_big_1.jpg';

      case MediaType.PlayerStream:
        return '/v6/Content/images/player_stream/thumbnails/streaming_icon_large.png';

      default:
        return '/v5/medias/channel/thumbnails/channel_big_1.jpg';
    }
  };

  private createDaysOfWeek = () => {
    const elements: any = [];
    for (let i = 0; i < 7; i++) {
      elements.push(
        <label key={i} className={'days ' + this.isDayValid(i)}>
          {this.getWeekdaysByName(i)}{' '}
        </label>
      );
    }
    return elements;
  };

  public render = () => {
    if (!this.props.media) {
      return <div />;
    }

    const thumbUrl = this.generateThumbnailUrl();
    const mediaInfo = this.props.media;

    return (
      <div className="appSideBar">
        <div className="imageContainer">
          <img className="imgPreview" src={thumbUrl} />
        </div>
        <span className={'properties-icon-' + mediaInfo.mediaType + ' ap-icon'} />
        <div className="ap-generic-properties-title" title={mediaInfo.name}>
          {mediaInfo.name}
        </div>
        <div className="ap-generic-properties-ids">{mediaInfo.id}</div>
        <br />
        <div className="ap-timeline-schTitle">SCHEDULING</div>
        <div className="ap-timeline-flex">
          <div className="ap-timeline-flex-row">
            <div className="ap-timeline-flex-item left">Start date:</div>
            <div className="ap-timeline-flex-item right">{format(mediaInfo.startDate, 'DD/MM/YYYY')}</div>
          </div>
          <div className="ap-timeline-flex-row">
            <div className="ap-timeline-flex-item left">End date:</div>
            <div className="ap-timeline-flex-item right">{format(mediaInfo.endDate, 'DD/MM/YYYY')}</div>
          </div>
          <div className="ap-timeline-flex-row">
            <div className="ap-timeline-flex-item left">Start time:</div>
            <div className="ap-timeline-flex-item right">{format(mediaInfo.startTime, 'h:mm:ss A')}</div>
          </div>
          <div className="ap-timeline-flex-row">
            <div className="ap-timeline-flex-item left">End time:</div>
            <div className="ap-timeline-flex-item right">{format(mediaInfo.endTime, 'h:mm:ss A')}</div>
          </div>
        </div>
        <br />
        <div id="weekDaysContainer">{this.createDaysOfWeek()}</div>
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/timeline/mediaInfo/MediaInfo.tsx